/**
 * Sets target="_blank" for external links and adds data-external attribute.
 *
 * @param {void}
 * @return {void}
 */
export function setExternalLink() {
    const currentDomain = window.location.hostname;
    const anchors = document.querySelectorAll(`a:not([href*="${currentDomain}"], [href^="#"], .no-external-link)`);
    anchors.forEach((anchor) => {
        const href = anchor.href.toLowerCase();
        const isExternal = href.startsWith('http://') || href.startsWith('https://') || href.endsWith('.pdf') || href.endsWith('.docx') || href.endsWith('.doc');
        if (isExternal) {
            anchor.setAttribute('rel', 'noopener noreferrer');
            anchor.setAttribute('target', '_blank');
            anchor.setAttribute('data-link-external', 'true');
        }
    });
}
